import { useEffect } from "react";
import Lenis from "lenis";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { WhyFranchise } from "@/components/WhyFranchise";
import { HowItWorks } from "@/components/HowItWorks";
import { TurnkeyStore } from "@/components/TurnkeyStore";
import { Investment } from "@/components/Investment";
import { Gallery } from "@/components/Gallery";
import { Stats } from "@/components/Stats";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { NewsBlog } from "@/components/NewsBlog";
import { StoreMap } from "@/components/StoreMap";
import { ContactForm } from "@/components/ContactForm";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";

export default function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, wheelMultiplier: 0.9 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain bg-[#FAFAF7] text-[#1A1A1A]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <WhyFranchise />
        <HowItWorks />
        <TurnkeyStore />
        <Investment />
        <Gallery />
        <Stats />
        <Testimonials />
        <FAQ />
        <NewsBlog />
        <StoreMap />
        <ContactForm />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
